import { render, staticRenderFns } from "./DisplayTeamList.vue?vue&type=template&id=3c838828&scoped=true"
import script from "./DisplayTeamList.vue?vue&type=script&lang=ts"
export * from "./DisplayTeamList.vue?vue&type=script&lang=ts"
import style0 from "./DisplayTeamList.vue?vue&type=style&index=0&id=3c838828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c838828",
  null
  
)

export default component.exports